import type { ChargerRepository } from '@/core/charger'
import type { UseCase } from '@/core/shared'

export const getAmountOfChargersWithUpdates:
UseCase<ChargerRepository, 'getAmountOfChargersWithUpdates'> = repository => {
  return async (groupUid) => {
    return await repository.getAmountOfChargersWithUpdates(groupUid)
  }
}
